if (typeof debounce === 'undefined') {
  var debounce = function (fn, wait) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.mobile_toggle = this.toggle.querySelector('.mobile-toggle');
      this.a_bar = document.querySelector('.announcement-bar-section');

      this._syncMobileMenuAccessibility = () => {
        const isOpen = this.toggle.hasAttribute('open');
        this.mobile_toggle.setAttribute('aria-expanded', String(isOpen));
        this.mobile_toggle.setAttribute('aria-label', document.documentElement.lang.toLowerCase().split('-')[0] === 'fr' ? (isOpen ? 'Fermer le menu' : 'Ouvrir le menu') : document.documentElement.lang.toLowerCase().split('-')[0] === 'es' ? (isOpen ? 'Cerrar el menú' : 'Abrir el menú') : (isOpen ? 'Close menu' : 'Open menu'));
      };
      this.toggle.addEventListener('toggle', this._syncMobileMenuAccessibility);
      this._syncMobileMenuAccessibility();

      this.isTransitioning = false;
      this.lastScrollPos = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          const wasOpen = this.toggle.hasAttribute('open');
          this.toggle.removeAttribute('open');
          this.toggle.classList.remove('active');
          document.body.classList.remove('overflow-hidden', 'senlan-mobile-menu-open');
          this._syncMobileMenuAccessibility();
          if (wasOpen) this.mobile_toggle.focus();
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      this.mobile_toggle.addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden', 'senlan-mobile-menu-open');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden', 'senlan-mobile-menu-open');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Cache sticky offset once — only needs recalculating on resize, not every scroll
      this._stickyOffset = this.offsetTop;

      // Store bound references for disconnectedCallback cleanup
      this._onScroll = this._scrollHandler.bind(this);
      this._onResize = this._resizeHandler.bind(this);

      // Single passive scroll handler replaces four separate scroll listeners
      window.addEventListener('scroll', this._onScroll, { passive: true });

      // Resize handler for values that only change on resize, not scroll
      window.addEventListener('resize', this._onResize, { passive: true });

      // Initial state
      this._scrollHandler();
      this._resizeHandler();

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      this.toggle.removeEventListener('toggle', this._syncMobileMenuAccessibility);
    }

    _scrollHandler() {
      // Batch all reads first, then all writes — one layout per scroll tick
      const scrollY        = window.scrollY;
      const headerTop      = this.header_section.getBoundingClientRect().top;
      const headerHeight   = this.clientHeight;

      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', scrollY >= this._stickyOffset && scrollY > 0);
      }
      document.documentElement.style.setProperty('--header-offset', headerTop + 'px');
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      this._handleScrollDirection(scrollY);
    }

    _resizeHandler() {
      // Recache sticky offset after layout changes
      this._stickyOffset = this.offsetTop;

      // Announcement height never changes on scroll, only on resize
      if (this.a_bar) {
        document.documentElement.style.setProperty('--announcement-height', this.a_bar.clientHeight + 'px');
      }
    }

    _handleScrollDirection(scrollY) {
      if (!this.isTransitioning && this.classList.contains('header-hide-menu--active')) {
        if (scrollY < 200) {
          this.showMenu();
        } else if (this.lastScrollPos < scrollY) {
          this.hideMenu();
        } else if (this.lastScrollPos - 5 > scrollY) {
          this.showMenu();
        }
        this.lastScrollPos = scrollY;
      }
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const parentLinks = this.menu.dataset.parentLinks === 'true';

      if (parentLinks) {
        event.preventDefault();

        const isArrow = event.target.closest('summary > span');

        if (isArrow) {
          if (detailsElement.hasAttribute('open')) {
            detailsElement.removeAttribute('open');
            return;
          }
          detailsElement.setAttribute('open', '');
        } else {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }
          return;
        }
      }

      // Clone deferred template on first open
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));

        // Re-bind listeners for newly cloned elements
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button =>
          button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
        detailsElement.querySelectorAll('details.link-container summary').forEach(summary =>
          summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
      }

      // Only reset scroll position when opening a top-level sub-menu (which slides in as a new view).
      // Nested accordion details inside an already-open sub-menu should not jump the menu to the top.
      const isTopLevel = !detailsElement.parentElement.closest('details');
      if (isTopLevel && this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    showMenu() {
      this.classList.remove('header--unpin');
      this.isTransitioning = true;
      setTimeout(() => {
        this.lastScrollPos = window.scrollY;
        this.isTransitioning = false;
        this._handleScrollDirection(window.scrollY);
      }, 300);
    }

    hideMenu() {
      if (!this.isTransitioning) {
        this.classList.add('header--unpin');
        this.isTransitioning = true;
        setTimeout(() => {
          this.lastScrollPos = window.scrollY;
          this.isTransitioning = false;
          this._handleScrollDirection(window.scrollY);
        }, 300);
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // DOM queries moved from constructor to connectedCallback
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');

      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {
          this.setMenuHeight();
          if (!this.submenus.length) {
            return;
          }
          this.resizeSubMenus();
        }, 100));
      });

      // Defer layout read until after paint
      requestAnimationFrame(() => this.setMenuHeight());

      this.senlanNoJumpLinks = this.querySelectorAll('.thb-full-menu > li.menu-item-has-children > a[href="#"]');
      this.senlanNoJumpLinks.forEach((link) => {
        link.addEventListener('click', (event) => event.preventDefault());
      });
    }

    resizeSubMenus() {
      // Batch all reads across all submenus first, then apply all writes
      const results = [];
      this.submenus.forEach((submenu) => {
        submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu').forEach((subSubmenu) => {
          results.push({
            el: subSubmenu.parentElement,
            overflowing: subSubmenu.getBoundingClientRect().right > window.innerWidth
          });
        });
      });
      results.forEach(({ el, overflowing }) => {
        el.classList.toggle('left-submenu', overflowing);
      });
    }

    setMenuHeight() {
      let h = this.clientHeight;
      if (h > 20) {
        document.documentElement.style.setProperty('--menu-height', h + 'px');
      }
    }
  }

  customElements.define('full-menu', FullMenu);
}

/* Local-only accessibility behavior for the audited V3 More dropdown. */
(() => {
  const selector = '.senlan-header-more > a[aria-controls="senlan-header-more-menu"]';

  const setOpen = (trigger, isOpen) => {
    const item = trigger.closest('.senlan-header-more');
    if (!item) return;
    item.classList.toggle('senlan-more-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
  };

  const closeAll = (except) => {
    document.querySelectorAll(selector).forEach((trigger) => {
      if (trigger !== except) setOpen(trigger, false);
    });
  };

  const bindMoreMenu = () => {
    document.querySelectorAll(selector).forEach((trigger) => {
      if (trigger.dataset.senlanMoreBound === 'true') return;
      trigger.dataset.senlanMoreBound = 'true';
      const item = trigger.closest('.senlan-header-more');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const nextState = !item.classList.contains('senlan-more-open');
        closeAll(trigger);
        setOpen(trigger, nextState);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          const nextState = !item.classList.contains('senlan-more-open');
          closeAll(trigger);
          setOpen(trigger, nextState);
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(trigger, false);
          trigger.focus();
        }
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(trigger, false);
          trigger.focus();
        }
      });
    });

    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('.senlan-header-more').forEach((item) => {
        if (!item.contains(event.target)) {
          const trigger = item.querySelector(selector);
          if (trigger) setOpen(trigger, false);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMoreMenu, { once: true });
  } else {
    bindMoreMenu();
  }
})();
